
    document.addEventListener("DOMContentLoaded", function(){


    
    document.querySelectorAll(".wellness-left .categories").forEach((category) => {
        category.addEventListener("click", () => {
            document.querySelectorAll(".wellness-left .categories").forEach((cat) => {
                cat.classList.remove("active");
                const icon = cat.querySelector(".toggle-icon");
                if (icon) {
                    icon.src = "https://cdn.shopify.com/s/files/1/0697/1015/1902/files/add_icon_b5ceb079-29fe-4590-8c59-87fc1887b0b3.png?v=1757581151";
                    icon.alt = "expand";
                }
            });
            category.classList.add("active");
            const activeIcon = category.querySelector(".toggle-icon");
            if (activeIcon) {
                activeIcon.src = "https://cdn.shopify.com/s/files/1/0697/1015/1902/files/dakshin-minus.svg?v=1763549243";
                activeIcon.alt = "collapse";
            }
            const targetId = category.getAttribute("data-target");
            document.querySelectorAll(".tab-content-wellness").forEach((content) => {
                content.classList.remove("active");
            });
            document.getElementById(targetId).classList.add("active");
        });
    });

    const defaultActiveCategory = document.querySelector(".wellness-left .categories.active");
    if (defaultActiveCategory) {
        const icon = defaultActiveCategory.querySelector(".toggle-icon");
        if (icon) {
            icon.src = "https://cdn.shopify.com/s/files/1/0697/1015/1902/files/dakshin-minus.svg?v=1763549243";
            icon.alt = "collapse";
        }
        const targetId = defaultActiveCategory.getAttribute("data-target");
        if (targetId) {
            document.querySelectorAll(".tab-content-wellness").forEach((content) => {
                content.classList.remove("active");
            });
            const defaultContent = document.getElementById(targetId);
            if (defaultContent) {
                defaultContent.classList.add("active");
            }
        }
    }

    const wellnessSiwper = new Swiper(".wellnessSiwper", {
        loop: true,
        slidesPerView: 1.2,
        spaceBetween: 20,
        navigation: {
            nextEl: ".wellness_slider_arrow_right",
            prevEl: ".wellness_slider_arrow_left",
        },
        autoplay: { delay: 2000, disableOnInteraction: true },
        breakpoints: {
            600: { slidesPerView: 1.3, spaceBetween: 20 },
            768: { slidesPerView: 1.6, spaceBetween: 20 },
            1024: { slidesPerView: 2, spaceBetween: 30 },
            1300: { slidesPerView: 2.3, spaceBetween: 40 },
        },
    });

      document.querySelectorAll('.categories').forEach((card) => {
    let clickedOnce = false;

    // Title text
    const title = card.querySelector('.text');

    // Button anchor
    const button = card.querySelector('a');

    const handleClick = (e) => {
      const isActive = card.classList.contains('active');

      // FIRST CLICK → activate accordion, prevent opening link
      if (!isActive) {
        e.preventDefault();

        clickedOnce = true;

        // Remove active from all
        document.querySelectorAll('.categories').forEach((el) => el.classList.remove('active'));
        document.querySelectorAll('.wellness-right-wrap').forEach((el) => el.classList.remove('active'));

        // Add active to clicked one
        card.classList.add('active');
        document.getElementById(card.dataset.target).classList.add('active');

        return;
      }

      // IF ACTIVE:
      // First click on active card → block navigation
      if (clickedOnce === false) {
        e.preventDefault();
        clickedOnce = true;
        return;
      }

      // Second click → allow navigation
      // Do nothing here → default anchor behavior
    };

    // Click on title or button should behave same
    title.addEventListener('click', handleClick);
    button.addEventListener('click', handleClick);
  });

        });